import _ from 'lodash';

$(document).on('ready turbolinks:load', () => {
  $('form.edit_depot')
    .find('.btn-row-actions.btn-edit.depot-edit').off('click').on('click', ({ currentTarget }) => {
      const $li = $(currentTarget).parents('li').addClass('edit-mode');
      $li.find('.item-title').text($li.find('input').filter((i, input) => _.endsWith(input.id, 'name')).val());
    });
  $('#depots-list li').off('click').on('click', ({ target, currentTarget }) => {
    const $target = $(target);
    if ($target.hasClass('depot-action') || $target.parents('.depot-action').length) { return; }

    // Select depot
    const magicSuggest = $('#depot-block .form-control').data('magicSuggest');
    if (!magicSuggest) { return; }
    magicSuggest.clear();
    magicSuggest.setData(_.map($('#depots-list li'), elem => ({
      id: $(elem).find('input[name="depot[id]"]').val(),
      name: $(elem).find('input[name="depot[name]"]').val(),
    })));
    magicSuggest.setValue([$(currentTarget).find('input[name="depot[id]"]').val()]);
    $('#modal-depot-library').modal('toggle');
  });
});
